import React, { useEffect, useState } from "react";
import "../../styles/piqModal.scss";
import { toast } from "react-toastify";
import CustomInput from "./CustomInput";
import CustomTextarea from "./CustomTextarea";
import CustomSelect from "./CustomSelect";
import { FaEdit, FaPlus } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { TiTick } from "react-icons/ti";
import { MdDelete } from "react-icons/md";
import userService from "../../services/userService";
import ButtonLoader from "./ButtonLoader";
import CustomButton from "./CustomButton";
import CustomModal from "./CustomModal";

const PIQModal = ({ show, setShow, myPIQ, PIQLoading, fetchPIQ }) => {
  const [createPIQLoading, setCreatePIQLoading] = useState(false);

  const [piqFormData, setPiqFormData] = useState({
    fullName: "",
    address: "",
    familiyIncome: "",
    height: "",
    weight: "",
    SSBRecord: "",
  });

  // INPUT CHNAGE HANDLER
  const handleInputChange = (e) => {
    const { value, name } = e.target;
    setPiqFormData({
      ...piqFormData,
      [name]: value,
    });
  };

  // QUALIFICATION DETAILS START
  const [addMoreQualification, setAddMoreQualification] = useState(true);
  const [editEducation, setEditEducation] = useState(false);
  const [editEduIndex, setEditEduIndex] = useState("");
  const [qualifications, setQualifications] = useState([]);
  const [educationObj, setEducationObj] = useState({
    grade: "",
    obtainedPercentage: "",
    passingYear: "",
  });

  const handleEduInputChange = (e) => {
    const { value, name } = e.target;
    setEducationObj({
      ...educationObj,
      [name]: value,
    });
  };

  // Initiate Edit Function
  const handleEditInitiate = (index) => {
    setEditEduIndex(index); // set selected index in the state
    const data = qualifications.find((_, i) => i === index);
    setEducationObj({
      grade: data?.grade,
      obtainedPercentage: data?.obtainedPercentage,
      passingYear: data?.passingYear,
    });
    setAddMoreQualification(false);
    setEditEducation(true);
  };

  // normalize initated edit function
  const handleNormaliseEditInitiate = () => {
    setEditEduIndex(""); // blank the state
    setEducationObj({
      grade: "",
      obtainedPercentage: "",
      passingYear: "",
    });
    setEditEducation(false);
  };

  // Edit/Update Qualification in list
  const handleUpdateEdu = (index) => {
    const updatedQualifications = qualifications.map((item, i) =>
      i === index ? educationObj : item
    );
    setQualifications(updatedQualifications);
    setEducationObj({
      grade: "",
      obtainedPercentage: "",
      passingYear: "",
    });
    setEditEducation(false);
  };

  // Delete Qualification from list
  const handleDeleteEdu = (index) => {
    const updatedQualifications = qualifications.filter((_, i) => i !== index);
    setQualifications(updatedQualifications);
  };

  // Add Qualification in list
  const handleAddQualification = () => {
    if (!educationObj.grade) {
      toast.warning("Please fill Grade/Education Title");
    } else if (!educationObj.obtainedPercentage) {
      toast.warning("Please fill obtained percentage");
    } else if (!educationObj.passingYear) {
      toast.warning("Please fill passing year");
    } else {
      setQualifications([...qualifications, educationObj]);
      setEducationObj({
        grade: "",
        obtainedPercentage: "",
        passingYear: "",
      });
      // setAddMoreQualification(false); // Close Add More inputs
    }
  };
  // QUALIFICATION DETAILS ENDS

  // HOBBIES AND INTEREST START
  const [addMoreHobbies, setAddMoreHobbies] = useState(true);
  const [editHobbies, setEditHobbies] = useState(false);
  const [editHobbyIndex, setEditHobbyIndex] = useState("");
  const [hobbies, setHobbies] = useState([]);
  const [hobbyString, setHobbyString] = useState("");

  // Initiate Edit Hobby Function
  const handleEditHobbyInitiate = (index) => {
    setEditHobbyIndex(index); // set selected index in the state
    const data = hobbies.find((_, i) => i === index);
    setHobbyString(data); // set data in hobby string
    setAddMoreHobbies(false);
    setEditHobbies(true);
  };

  // normalize initated edit Hobby function
  const handleNormaliseEditHobbyInitiate = () => {
    setEditHobbyIndex(""); // blank the state
    setHobbyString("");
    setEditHobbies(false);
  };

  // Edit/Update Qualification in list
  const handleUpdateHobby = (index) => {
    const updatedHobbies = hobbies.map((item, i) =>
      i === index ? hobbyString : item
    );
    setHobbies(updatedHobbies);
    setHobbyString("");
    setEditHobbies(false);
  };

  // Delete Qualification from list
  const handleDeleteHobby = (index) => {
    const updatedHobbies = hobbies.filter((_, i) => i !== index);
    setHobbies(updatedHobbies);
  };

  // Add Qualification in list
  const handleAddNewHobby = () => {
    if (!hobbyString) {
      toast.warning("Please fill hobby/Interest");
    } else {
      setHobbies([...hobbies, hobbyString]);
      setHobbyString("");
      //   setAddMoreHobbies(false); // Close Add More inputs
    }
  };
  // HOBBIES AND INTEREST ENDS

  // SPORTS FUNCTIONALITY START
  const [addMoreSports, setAddMoreSports] = useState(true);
  const [editSports, setEditSports] = useState(false);
  const [editSportsIndex, setEditSportsIndex] = useState("");
  const [sports, setSports] = useState([]);
  const [sportString, setSportString] = useState("");

  // Initiate Edit Sport Function
  const handleEditSportsInitiate = (index) => {
    setEditSportsIndex(index); // set selected index in the state
    const data = sports.find((_, i) => i === index);
    setSportString(data); // set data in Sport string
    setAddMoreSports(false);
    setEditSports(true);
  };

  // normalize initated edit Sport function
  const handleNormaliseEditSportInitiate = () => {
    setEditSportsIndex(""); // blank the state
    setSportString("");
    setEditSports(false);
  };

  // Edit/Update Qualification in list
  const handleUpdateSports = (index) => {
    const updatedSports = sports.map((item, i) =>
      i === index ? sportString : item
    );
    setSports(updatedSports);
    setSportString("");
    setEditSports(false);
  };

  // Delete Qualification from list
  const handleDeleteSport = (index) => {
    const updatedSports = sports.filter((_, i) => i !== index);
    setSports(updatedSports);
  };

  // Add Qualification in list
  const handleAddNewSport = () => {
    if (!sportString) {
      toast.warning("Please fill in the input box");
    } else {
      setSports([...sports, sportString]);
      setSportString("");
      //   setAddMoreSports(false); // Close Add More inputs
      toast.success("New data added in list");
    }
  };
  // SPORTS FUNCTIONALITY ENDS

  //   // GET MY PIQ STARTS
  useEffect(() => {
    if (myPIQ) {
      setPiqFormData({
        fullName: myPIQ?.fullName,
        address: myPIQ?.address,
        familiyIncome: myPIQ?.familiyIncome,
        height: myPIQ?.height,
        weight: myPIQ?.weight,
        SSBRecord: myPIQ?.SSBRecord,
      });
      setHobbies(myPIQ?.hobbyAndInterest);
      setSports(myPIQ?.sports);
      setQualifications(myPIQ?.qualifications);
    }
  }, [myPIQ]);
  //   // GET MY PIQ ENDS

  // UPDATE/CREATE PIQ START
  const handleUpdatePIQ = async () => {
    setCreatePIQLoading(true);
    try {
      let result = await userService.updatePIQ({
        fullName: piqFormData.fullName,
        address: piqFormData.address,
        familiyIncome: piqFormData.familiyIncome,
        height: piqFormData.height,
        weight: piqFormData.weight,
        SSBRecord: piqFormData.SSBRecord,
        hobbies,
        sports,
        qualifications,
      });

      if (result?.data?.success) {
        toast.success("PIQ Updated Successfully");
        setEditEducation(false); // Education Edit False
        setEditHobbies(false); // Hobbies Edit False
        setEditSports(false); // Sports Edit False
        result = {}; //
        fetchPIQ();
        setShow(false);
      }
    } catch (error) {
      console.error("Error updating PIQ:", error);
      setCreatePIQLoading(false);
    } finally {
      setCreatePIQLoading(false);
    }
  };
  // UPDATE/CREATE PIQ ENDS

  return (
    <CustomModal show={show} setShow={setShow}>
      {PIQLoading
        ? "Loading..."
        : show && (
            <div className="piq_modal_main">
              <CustomInput
                label="Full Name"
                type="text"
                placeholder="Full Name"
                impStar={"*"}
                name="fullName"
                value={piqFormData?.fullName}
                onChange={handleInputChange}
                borderColor={"#f2f2f2"}
              />
              <CustomInput
                label="Total Familiy Income (in Rupees)"
                type="number"
                impStar={"*"}
                placeholder="Total Familiy Income"
                name="familiyIncome"
                value={piqFormData?.familiyIncome}
                onChange={handleInputChange}
                borderColor={"#f2f2f2"}
              />
              <CustomInput
                label="Height (in Meters)"
                type="number"
                impStar={"*"}
                placeholder="Height (in Meters)"
                name="height"
                value={piqFormData?.height}
                onChange={handleInputChange}
                borderColor={"#f2f2f2"}
              />
              <CustomInput
                label="Weight (in Kgs)"
                type="number"
                impStar={"*"}
                placeholder="Weight (in Kgs)"
                name="weight"
                value={piqFormData?.weight}
                onChange={handleInputChange}
                borderColor={"#f2f2f2"}
              />
              <CustomTextarea
                label="Address (Present Address)"
                type="number"
                impStar={"*"}
                placeholder="Enter Your Present Address"
                name="address"
                value={piqFormData?.address}
                onChange={handleInputChange}
                borderColor={"#f2f2f2"}
                rows={3}
                fullWidth={true}
              />
              <CustomSelect
                label="SSB Record"
                type="number"
                impStar={"*"}
                name="SSBRecord"
                value={piqFormData?.SSBRecord}
                onChange={handleInputChange}
                borderColor={"#f2f2f2"}
                fullWidth={true}
                optionArray={[
                  { option: "Fresher" },
                  { option: "Screen Out" },
                  { option: "Conference Out" },
                  { option: "Recommended" },
                ]}
              />

              {/* QUALIFICATION SECTION START */}
              <div className="tableOfPiq">
                <div className="heading">
                  <span>
                    Qualifications <abbr style={{ color: "red" }}>*</abbr>
                  </span>
                  <span
                    title="Add More Qualifications"
                    onClick={() => {
                      handleNormaliseEditInitiate();
                      setAddMoreQualification(!addMoreQualification);
                    }}
                    className="buttonSpan"
                  >
                    <FaPlus
                      style={{
                        transform: addMoreQualification ? "rotate(45deg)" : "",
                      }}
                    />{" "}
                    Add More
                  </span>
                </div>
                <div className="overflowSection">
                  <table>
                    <thead>
                      <tr>
                        <th>Grade Level</th>
                        <th>Marks (Obtained Percentage)</th>
                        <th>Passing Year</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {qualifications?.map((item, itemIndex) => (
                        <tr key={"qualification" + itemIndex}>
                          <td>
                            <input
                              readOnly={
                                editEducation && editEduIndex === itemIndex
                                  ? false
                                  : true
                              }
                              style={{
                                border:
                                  editEducation && editEduIndex === itemIndex
                                    ? "1px solid red"
                                    : "",
                              }}
                              type="text"
                              value={
                                editEducation && editEduIndex === itemIndex
                                  ? educationObj?.grade
                                  : item?.grade
                              }
                              onChange={handleEduInputChange}
                              name="grade"
                              placeholder="Ex: 10th/12th/B.Sc"
                            />
                          </td>
                          <td>
                            <input
                              readOnly={
                                editEducation && editEduIndex === itemIndex
                                  ? false
                                  : true
                              }
                              style={{
                                border:
                                  editEducation && editEduIndex === itemIndex
                                    ? "1px solid red"
                                    : "",
                              }}
                              type="number"
                              value={
                                editEducation && editEduIndex === itemIndex
                                  ? educationObj?.obtainedPercentage
                                  : item?.obtainedPercentage
                              }
                              onChange={handleEduInputChange}
                              name="obtainedPercentage"
                              placeholder="Ex: 85.3"
                            />
                          </td>
                          <td>
                            <input
                              readOnly={
                                editEducation && editEduIndex === itemIndex
                                  ? false
                                  : true
                              }
                              style={{
                                border:
                                  editEducation && editEduIndex === itemIndex
                                    ? "1px solid red"
                                    : "",
                              }}
                              type="number"
                              value={
                                editEducation && editEduIndex === itemIndex
                                  ? educationObj?.passingYear
                                  : item?.passingYear
                              }
                              onChange={handleEduInputChange}
                              name="passingYear"
                              placeholder="Ex: 2024"
                            />
                          </td>
                          <td>
                            <div className="buttonGrp">
                              {editEducation && editEduIndex === itemIndex ? (
                                <>
                                  <button
                                    title="Update Now"
                                    onClick={() => handleUpdateEdu(itemIndex)}
                                    className="editBtn"
                                    style={{ color: "green" }}
                                  >
                                    <TiTick />
                                  </button>
                                  <button
                                    title="Cancel"
                                    onClick={() =>
                                      handleNormaliseEditInitiate()
                                    }
                                    className="deleteBtn"
                                    style={{ color: "red" }}
                                  >
                                    <RxCross2 />
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    title="Edit/Update"
                                    onClick={() =>
                                      handleEditInitiate(itemIndex)
                                    }
                                    className="editBtn"
                                  >
                                    <FaEdit />
                                  </button>
                                  <button
                                    title="Remove/Delete"
                                    onClick={() => handleDeleteEdu(itemIndex)}
                                    className="deleteBtn"
                                  >
                                    <MdDelete />
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                      {addMoreQualification && (
                        <tr key="qualificationCreate">
                          <td>
                            <input
                              type="text"
                              value={educationObj?.grade}
                              onChange={handleEduInputChange}
                              name="grade"
                              placeholder="Ex: 10th/12th/B.Sc"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={educationObj?.obtainedPercentage}
                              onChange={handleEduInputChange}
                              name="obtainedPercentage"
                              placeholder="Ex: 85.3"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={educationObj?.passingYear}
                              onChange={handleEduInputChange}
                              name="passingYear"
                              placeholder="Ex: 2024"
                            />
                          </td>
                          <td>
                            <button onClick={handleAddQualification}>
                              <TiTick /> Add
                            </button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* QUALIFICATION SECTION ENDS */}

              {/* HOBBY AND INTEREST START */}
              <div className="tableOfPiq">
                <div className="heading">
                  <span>
                    Hobby & Interest <abbr style={{ color: "red" }}>*</abbr>
                  </span>
                  <span
                    title="Add More Hobbies"
                    onClick={() => {
                      handleNormaliseEditHobbyInitiate();
                      setAddMoreHobbies(!addMoreHobbies);
                    }}
                    className="buttonSpan"
                  >
                    <FaPlus
                      style={{
                        transform: addMoreHobbies ? "rotate(45deg)" : "",
                      }}
                    />{" "}
                    Add More
                  </span>
                </div>
                <div className="overflowSection">
                  <table>
                    <thead>
                      <tr>
                        <th>Hobby (Interest In)</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {hobbies?.map((item, itemIndex) => (
                        <tr key={"hobby" + itemIndex}>
                          <td>
                            <input
                              readOnly={
                                editHobbies && editHobbyIndex === itemIndex
                                  ? false
                                  : true
                              }
                              style={{
                                border:
                                  editHobbies && editHobbyIndex === itemIndex
                                    ? "1px solid red"
                                    : "",
                              }}
                              type="text"
                              value={
                                editHobbies && editHobbyIndex === itemIndex
                                  ? hobbyString
                                  : item
                              }
                              onChange={(e) => setHobbyString(e.target.value)}
                              name="hobbyString"
                              placeholder="Ex: Reading Books"
                            />
                          </td>
                          <td>
                            <div className="buttonGrp">
                              {editHobbies && editHobbyIndex === itemIndex ? (
                                <>
                                  <button
                                    title="Update Now"
                                    onClick={() => handleUpdateHobby(itemIndex)}
                                    className="editBtn"
                                    style={{ color: "green" }}
                                  >
                                    <TiTick />
                                  </button>
                                  <button
                                    title="Cancel"
                                    onClick={() =>
                                      handleNormaliseEditHobbyInitiate()
                                    }
                                    className="deleteBtn"
                                    style={{ color: "red" }}
                                  >
                                    <RxCross2 />
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    title="Edit/Update"
                                    onClick={() =>
                                      handleEditHobbyInitiate(itemIndex)
                                    }
                                    className="editBtn"
                                  >
                                    <FaEdit />
                                  </button>
                                  <button
                                    title="Remove/Delete"
                                    onClick={() => handleDeleteHobby(itemIndex)}
                                    className="deleteBtn"
                                  >
                                    <MdDelete />
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                      {addMoreHobbies && (
                        <tr key="hobbyCreate">
                          <td>
                            <input
                              type="text"
                              value={hobbyString}
                              onChange={(e) => setHobbyString(e.target.value)}
                              name="hobbyString"
                              placeholder="Ex: Reading Books"
                            />
                          </td>
                          <td>
                            <button onClick={handleAddNewHobby}>
                              <TiTick /> Add
                            </button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* HOBBY AND INTEREST ENDS */}

              {/* SPORTS SECTION START */}
              <div className="tableOfPiq">
                <div className="heading">
                  <span>
                    Sports <abbr style={{ color: "red" }}>*</abbr>
                  </span>
                  <span
                    title="Add More Sports"
                    onClick={() => {
                      handleNormaliseEditSportInitiate();
                      setAddMoreSports(!addMoreSports);
                    }}
                    className="buttonSpan"
                  >
                    <FaPlus
                      style={{
                        transform: addMoreSports ? "rotate(45deg)" : "",
                      }}
                    />{" "}
                    Add More
                  </span>
                </div>
                <div className="overflowSection">
                  <table>
                    <thead>
                      <tr>
                        <th>Sports</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sports?.map((item, itemIndex) => (
                        <tr key={"sport" + itemIndex}>
                          <td>
                            <input
                              readOnly={
                                editSports && editSportsIndex === itemIndex
                                  ? false
                                  : true
                              }
                              style={{
                                border:
                                  editSports && editSportsIndex === itemIndex
                                    ? "1px solid red"
                                    : "",
                              }}
                              type="text"
                              value={
                                editSports && editSportsIndex === itemIndex
                                  ? sportString
                                  : item
                              }
                              onChange={(e) => setSportString(e.target.value)}
                              name="sportString"
                              placeholder="Ex: Cricket/Football"
                            />
                          </td>
                          <td>
                            <div className="buttonGrp">
                              {editSports && editSportsIndex === itemIndex ? (
                                <>
                                  <button
                                    title="Update Now"
                                    onClick={() =>
                                      handleUpdateSports(itemIndex)
                                    }
                                    className="editBtn"
                                    style={{ color: "green" }}
                                  >
                                    <TiTick />
                                  </button>
                                  <button
                                    title="Cancel"
                                    onClick={() =>
                                      handleNormaliseEditSportInitiate()
                                    }
                                    className="deleteBtn"
                                    style={{ color: "red" }}
                                  >
                                    <RxCross2 />
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    title="Edit/Update"
                                    onClick={() =>
                                      handleEditSportsInitiate(itemIndex)
                                    }
                                    className="editBtn"
                                  >
                                    <FaEdit />
                                  </button>
                                  <button
                                    title="Remove/Delete"
                                    onClick={() => handleDeleteSport(itemIndex)}
                                    className="deleteBtn"
                                  >
                                    <MdDelete />
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                      {addMoreSports && (
                        <tr key="sportCreate">
                          <td>
                            <input
                              type="text"
                              value={sportString}
                              onChange={(e) => setSportString(e.target.value)}
                              name="sportString"
                              placeholder="Ex: Cricket/Football"
                            />
                          </td>
                          <td>
                            <button onClick={handleAddNewSport}>
                              <TiTick /> Add
                            </button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* SPORTS SECTION ENDS */}

              <CustomButton
                className="pro_update_btn"
                title={
                  createPIQLoading ? <ButtonLoader color="#f3ad6c" /> : `Update`
                }
                disabled={createPIQLoading}
                width="100px"
                onClick={handleUpdatePIQ}
              />
            </div>
          )}
    </CustomModal>
  );
};

export default PIQModal;
